import React, { createContext, useContext } from 'react';
import type { FormState } from '../../../types/publicForm.types';

interface FormContextValue {
  state: FormState;
  actions: {
    updateField: (questionId: string, value: any) => void;
    markFieldTouched: (questionId: string) => void;
    setVisibleChildQuestions: (visibleSet: Set<string>) => void;
    nextPage: () => void;
    previousPage: () => void;
    submitForm: () => Promise<void>;
  };
  formData?: {
    teamSlug?: string;
  };
}

export const FormContext = createContext<FormContextValue | null>(null);

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useFormContext must be used within FormContext.Provider');
  }
  return context;
};